import React from 'react';
import cls from 'classnames';
// import { useDispatch } from 'react-redux';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import { IconComp } from '../IconComponent';
import { ReactComponent as ArrowUpRight } from '../../../assets/svg/icons/arrow-up-right.svg';

export enum BackgroundColor {
  KIWI = 'kiwi',
  CLOUD = 'cloud',
  GRAPE = 'grape',
  LEMON = 'lemon',
  POMELO = 'pomelo',
}

interface TitleWithDescription {
  title: string;
  description: string;
  background: BackgroundColor;
  hasButton?: boolean;
  buttonURL?: string;
}

export const TitleWithDescription: React.FC<TitleWithDescription> = ({
  title,
  description,
  background,
  hasButton,
  buttonURL,
}) => {
  // const dispatch = useDispatch();
  const isBiggerThanMobile = useBreakpoint('48em');
  return (
    <section
      className={cls({
        'bg-cloud-800 text-onion-50': background === BackgroundColor.CLOUD,
      })}
    >
      <div
        className={cls({
          'mx-auto px-4 sm:px-8 lg:px-0 lg:mx-96 flex flex-col items-center text-center justify-center gap-5 py-8 border-b border-cloud-700':
            background === BackgroundColor.CLOUD,
        })}
      >
        <h2 className="text-display-md">{title}</h2>
        <p className="text-lg">{description}</p>
        {hasButton && (
          <a
            href={buttonURL}
            target="_blank"
            rel="noreferrer"
            className={cls(
              'sk-cta border border-cloud-900 rounded-xl text-black flex items-center justify-center transition ease-in-out duration-100 bg-kiwi-400 focus:bg-cloud-900 focus:text-white',
              {
                'px-2.5 py-1.5 gap-x-1 text-base': isBiggerThanMobile,
                'px-1.75 py-1 gap-x-1 text-sm': !isBiggerThanMobile,
              },
            )}
          >
            <span>Revoke.cash</span>
            <IconComp icon={ArrowUpRight} size={16.67} />
          </a>
        )}
      </div>
    </section>
  );
};
